import React from "react";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/src/components/ui/drawer";
import { FaChevronDown, FaCheck } from "react-icons/fa";
import gameAssets from "@themed-assets";
import { HEADER_GAME_TYPES } from "@/Poker/data/Constants";
import styles from "./GameTypeDrawer.module.css";
import { useNavigate } from "react-router";

const GAME_TYPE_OPTIONS = [
  {
    id: "cash",
    label: "Cash Games",
    icon: gameAssets.cashGames,
    type: HEADER_GAME_TYPES.CASH,
    description: "5Cr + Leaderboard",
  },
  {
    id: "tourney",
    label: "Tourneys",
    icon: gameAssets.tourneys,
    type: HEADER_GAME_TYPES.TOURNEYS,
    description: '250Cr + Prize Pool'
  },
  {
    id: "sng",
    label: "SNG",
    icon: gameAssets.SNGIcon,
    type: "SNG",
    description: "Sit and Go Tournaments",
  },
  {
    id: "freeroll",
    label: "Free Rolls",
    icon: gameAssets.freeRoll,
    type: "FREEROLL",
    description: "Play for free",
  },
];

export default function GameTypeDrawer({
  type = HEADER_GAME_TYPES.CASH,
  onGameTypeChange,
  className = "",
  children,
}) {
  const navigate = useNavigate();

  const handleGameTypeSelect = (selectedType) => {
    // console.log('Selected Type is >>> ', selectedType);
    if (onGameTypeChange) {
      onGameTypeChange(selectedType);
    }
    if (selectedType === HEADER_GAME_TYPES.CASH) {
      navigate('/cashLobby', { replace: true });
    } else if (selectedType === HEADER_GAME_TYPES.TOURNEYS) {
      navigate('/tourneyLobby', { replace: true });
    }
  };

  // console.log('THE TYPE IS >>> ', type);

  const getCurrentGameType = () => {
    return (
      GAME_TYPE_OPTIONS.find((option) => option.type === type) ||
      GAME_TYPE_OPTIONS[0]
    );
  };

  const currentGameType = getCurrentGameType();

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <div className={`${styles.gameTypeTrigger} ${className}`}>
          {children || (
            <div className={styles.gameType + " flex"}>
              <img src={currentGameType.icon} alt={currentGameType.label} />
              <span>{currentGameType.label}</span>
              <FaChevronDown color="var(--color-h-primary)" size={10} />
            </div>
          )}
        </div>
      </DrawerTrigger>
      <DrawerContent>
        <div className={styles.drawerContainer}>
          <DrawerTitle className={styles.drawerTitle}>Our Games</DrawerTitle>
          <div className={styles.gameTypeGrid}>
            {GAME_TYPE_OPTIONS.map((option) => (
              <DrawerClose
                key={option.id}
                className={`${styles.gameTypeCard} ${
                  type === option.type ? styles.active : ""
                }`}
                onClick={() => handleGameTypeSelect(option.type)}
              >
                <div className={styles.cardContent}>
                  <img
                    src={option.icon}
                    alt={option.label}
                    className={styles.cardIcon}
                  />
                  <div className={styles.cardText}>
                    <span className={styles.cardLabel}>{option.label}</span>
                    <span className={styles.cardDescription}>
                      {option.description}
                    </span>
                  </div>
                </div>
                {type === option.type && (
                  <div className={styles.activeIndicator}>
                    <FaCheck className={styles.checkIcon} />
                  </div>
                )}
              </DrawerClose>
            ))}
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
